export default {
    props: {
      value: {
        type: String,
        twoWay: true
      },
      type: {
        type: String,
        default: 'default'
      }
    }
  }


/** WEBPACK FOOTER **
 ** ./~/vue-loader/lib/selector.js?type=script&index=0!./src/radioGroup.vue
 **/